import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../store/UserContext';
import RoleSettingsService from '../services/RoleSettingsService';
import { MODULE_PACK_MAP, PACK_DEFINITIONS } from '../config/featurePacks';
import { useFeaturePacks } from '../store/FeaturePackContext';
import PackDisabledPanel from '../components/PackDisabledPanel';

export default function AccessRoute({ allow = [], module, children }) {
  const { user } = useUser();
  const { packs } = useFeaturePacks();
  const roleService = React.useMemo(() => new RoleSettingsService(), []);
  if (!user) return <Navigate to="/login" replace />;
  if (allow.length > 0 && !allow.includes(user.accessScope)) {
    return <Navigate to="/dashboard" replace />;
  }
  if (module) {
    const permissions = roleService.getPermissions(user.roleKey || (user.accessScope === 'admin' ? 'admin' : 'teacher'));
    if (!permissions?.[module]) {
      return <Navigate to="/dashboard" replace />;
    }
    const packId = MODULE_PACK_MAP[module];
    if (packId && packs?.[packId] === false) {
      const packName = PACK_DEFINITIONS.find((pack) => pack.id === packId)?.name || packId;
      return <PackDisabledPanel packName={packName} />;
    }
  }
  return children;
}
